import { setCloseModalAction, setOpenModalButton } from '../../modals'
import { createNewWishlistModal, getUserWishlistsRequest, showAddToWishlistModal } from '../../addToWishlist'
import { listWishlistItems } from './api'

// The chat opens over any page, and only listing pages render the wishlist
// modals and the store of wishlisted listings its hearts read and update.
// Safe to call again: what the page already has is left as it is.
export function prepareWishlist () {
  return Promise.all([addMissingModals(), addMissingStore()])
}

function addMissingModals () {
  const template = document.querySelector('.vjs-vera-wishlist-modals')
  if (!template) return

  Array.from(template.content.children)
    .filter(modal => !document.getElementById(modal.id))
    .forEach(modal => {
      document.body.appendChild(modal)
      setCloseModalAction(modal)
      modal.querySelectorAll('.vjs-modal-button').forEach(setOpenModalButton)
      if (modal.id === 'add-to-wishlist') {
        createNewWishlistModal()
        getUserWishlistsRequest()
      }
    })
}

async function addMissingStore () {
  if (document.querySelector('.vjs-wishlist-item-ids')) return

  const store = document.createElement('input')
  store.type = 'hidden'
  store.className = 'vjs-wishlist-item-ids'
  store.value = '[]'
  document.body.appendChild(store)

  try {
    const { wishlistItems } = await listWishlistItems()
    store.value = JSON.stringify(wishlistItems.map(item => [item.id, item.listing_id]))
  } catch {
    // Hearts start empty; adding still works.
  }
}

// A guest's heart in the chat asks them to log in first: remember where they were.
export function rememberWishlistIntent (conversationId, listingId) {
  try {
    window.sessionStorage.setItem(wishlistIntentKey(), JSON.stringify({ conversationId, listingId }))
  } catch {
    // Without storage the login still restores the wishlist modal, just not the chat.
  }
}

function takeWishlistIntent () {
  try {
    const intent = JSON.parse(window.sessionStorage.getItem(wishlistIntentKey()) || 'null')
    window.sessionStorage.removeItem(wishlistIntentKey())
    return intent
  } catch {
    return null
  }
}

// The page a wishlist login lands on names the listing in #vjs-add-to-wishlist-active,
// in its own modal or in the chat's copy.
function restoreMarker () {
  return document.getElementById('vjs-add-to-wishlist-active') ||
    document.querySelector('.vjs-vera-wishlist-modals')?.content.querySelector('#vjs-add-to-wishlist-active')
}

// Back in the chat when the login started there; otherwise the page restores its own
// modal, and a page without one gets the chat's copy.
export async function resumeWishlistAfterLogin (chat) {
  if (document.body.dataset.loggedIn !== 'true') return

  const intent = takeWishlistIntent()
  const marker = restoreMarker()
  if (!marker) return

  if (intent && String(intent.listingId) === marker.dataset.listingId) {
    await chat.open({ conversationId: intent.conversationId, entryPoint: 'wishlist_login' })
    marker.remove()
    return offerWishlists(chat.transcript.element, intent.listingId)
  }

  if (!marker.isConnected) {
    await prepareWishlist()
    showAddToWishlistModal(document.getElementById('vjs-add-to-wishlist-active'))
  }
}

// The transcript streams in after the chat opens: wait for the tile, then open its wishlists.
async function offerWishlists (transcript, listingId) {
  const selector = `.vjs-vera-result[data-productid="${listingId}"] button.vjs-listing-tile-add-to-wishlist-button, .vjs-vera-result[data-productid="${listingId}"] button.vjs-listing-wishlisted`
  const heart = await waitFor(transcript, selector)
  if (!heart || heart.classList.contains('vjs-listing-wishlisted')) return

  heart.scrollIntoView({ block: 'center', inline: 'center' })
  heart.click()
}

// Gives up after 10s.
function waitFor (root, selector) {
  return new Promise(resolve => {
    const found = root.querySelector(selector)
    if (found) return resolve(found)

    const observer = new window.MutationObserver(() => {
      const element = root.querySelector(selector)
      if (!element) return
      observer.disconnect()
      resolve(element)
    })
    observer.observe(root, { childList: true, subtree: true })
    setTimeout(() => {
      observer.disconnect()
      resolve(null)
    }, 10000)
  })
}

function wishlistIntentKey () {
  return 'veraWishlistAfterLogin'
}
